import { render, staticRenderFns } from "./roetveeg.vue?vue&type=template&id=29e1acd6&"
import script from "./roetveeg.vue?vue&type=script&lang=js&"
export * from "./roetveeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports